import { Components, Theme } from '@mui/material';
import type {} from '@mui/x-date-pickers/themeAugmentation';

export const timeFieldTheme: Components<Theme> = {
  MuiTimeField: {
    defaultProps: {
      slotProps: {
        textField: {
          sx: (theme: Theme) => ({
            width: '100%',
            '& .MuiPickersOutlinedInput-root': {
              ...theme.typography.body2,
              background: theme.palette.background.default,
              borderRadius: theme.spacing(2.5),
              padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
            },
            '& .MuiPickersInputBase-input': {
              ...theme.typography.body2,
              height: 'auto',
            },
            '& .MuiPickersInputBase-sectionsContainer': {
              padding: theme.spacing(0),
              width: 'auto',
            },
            '& .MuiPickersOutlinedInput-notchedOutline': {
              borderColor: theme.palette.grey[400],
            },
            '&:hover .MuiPickersOutlinedInput-notchedOutline': {
              borderColor: theme.palette.grey[600],
            },
            '& .Mui-focused .MuiPickersOutlinedInput-notchedOutline': {
              borderColor: theme.palette.primary.main,
              borderWidth: '1px',
            },
          }),
        },
      },
    },
  },
};
